import { usePostHttp } from "../../../../hooks/http/http.hook";
import type { IProposalSocial } from "./get-proposal-socials.hook";

interface IBody {
  filter: {
    followers:
      | {
          min: number | undefined;
          max: number | undefined;
        }
      | undefined;
    gender: string[] | undefined;
    genre: string[] | undefined;
  };
}

export interface IResponse {
  campaignProposalSocials: Array<IProposalSocial>;
}

export function useProposalSocialApplyFilterHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/brand/campaigns/proposals/:proposalId/filter",
  });
}
